module.exports = __webpack_public_path__ + "static/media/34.cb713680.png";